<template>
	<ActivityLayout class="kr-confidence-activity">
		<template #badge>
			<ConfidenceChangeActivityBadge
				:confidence-level="activity.to"
				:direction="activity.direction"
			/>
		</template>
		<template #text>
			<p v-html="translate( `text`, {
				changedBy: activity.changedBy,
				previousConfidenceLevel,
				currentConfidenceLevel,
			} )"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import ConfidenceChangeActivityBadge from "../Activity/ConfidenceChangeActivityBadge";

export default {
	name: "KRConfidenceActivity",
	components: {
		ActivityLayout,
		ConfidenceChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, to:ConfidenceLevel, from:ConfidenceLevel, direction:Direction */
		activity: {
			type: Object,
			required: true,
		},
	},
	computed: {
		previousConfidenceLevel() {
			return this.translate( `confidence${ this.activity.from }` );
		},
		currentConfidenceLevel() {
			return this.translate( `confidence${ this.activity.to }` );
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.KRConfidenceActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
